import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@vimeo/bokeh';

import { ReportActions, ReportReasonList } from './ReportContent';
import { Reason, REASON_UNSELECTED, ReportReason } from './types';

export { REASON_UNSELECTED } from './types';
export type { Reason, VideoReason, VideoCommentReason, ReportReason } from './types';

export interface ReportModalProps {
  header: string;
  cta: string;
  reasons: ReportReason[];
  isOpen: boolean;
  isPosting: boolean;
  reportReason: Reason;
  setReportReason: (value: Reason) => void;
  onCloseCleanup: () => void;
  submitReport: () => void;
}

export const ReportModal = ({
  header,
  cta,
  reasons,
  isOpen,
  isPosting,
  reportReason,
  setReportReason,
  onCloseCleanup,
  submitReport,
}: ReportModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onCloseCleanup} scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxHeight="calc(100% - 3rem)">
        <ModalHeader>{header}</ModalHeader>
        <ModalCloseButton />
        <ModalBody flex="1 1 0%" overflow="auto">
          <ReportReasonList
            cta={cta}
            reasons={reasons}
            reportReason={reportReason}
            setReportReason={setReportReason}
          />
        </ModalBody>
        <ModalFooter border="none" py="200">
          <ReportActions
            isSubmitDisabled={reportReason == REASON_UNSELECTED || isPosting}
            onClose={onCloseCleanup}
            onSubmit={submitReport}
          />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
